import * as React from "react";

import { useTranslation } from "react-i18next";

import { XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

export interface BulkActionsBarProps {
  count: number;
  onClear: () => void;
  children: React.ReactNode;
}

export function BulkActionsBar({
  count,
  onClear,
  children,
}: BulkActionsBarProps) {
  const { t } = useTranslation();
  return (
    <div className="bg-muted/40 flex items-center gap-3 rounded-md border px-3 py-2 text-sm">
      <span className="text-muted-foreground">
        {t("components.dataTable.bulkActions.selectedCount", { count })}
      </span>
      {children}
      <Button
        variant="ghost"
        size="icon"
        onClick={onClear}
        title={t("components.dataTable.bulkActions.clearSelection")}
        aria-label={t("components.dataTable.bulkActions.clearSelection")}
      >
        <XIcon className="size-4" />
      </Button>
    </div>
  );
}
